import { ref, watch, computed } from 'vue'
import ApiService from '@/services/api.js'

export function useServices(locale) {
  // Reactive state
  const rawServices = ref([])
  const isLoadingData = ref(false)

  // Computed services with proper locale reactivity
  const services = computed(() => {
    if (rawServices.value.length === 0) return []
    
    return rawServices.value.map(service => ({
      id: service.id,
      title: locale?.value === 'tr' ? (service.title_tr || service.title) : (service.title_en || service.title),
      description: locale?.value === 'tr' ? (service.description_tr || service.description) : (service.description_en || service.description),
      icon: service.icon || '⚡',
      features: service.features ? JSON.parse(service.features) : [],
      price: service.price
    }))
  })

  // Services yükleme
  const loadServices = async () => {
    try {
      console.log('🔄 Loading services data...')
      isLoadingData.value = true
      
      const servicesData = await ApiService.getServices()
      console.log('⚙️ Services API response:', servicesData)
      
      if (servicesData && servicesData.length > 0) {
        rawServices.value = servicesData
        console.log('✅ Services data loaded:', rawServices.value.length, 'services')
      } else {
        console.warn('⚠️ No services data received, using fallback')
        setFallbackServices()
      }
    } catch (error) {
      console.error('❌ Hizmetler yüklenemedi:', error)
      setFallbackServices()
    } finally {
      isLoadingData.value = false
    }
  }

  // Fallback services
  const setFallbackServices = () => {
    rawServices.value = [
      {
        id: 1,
        title_tr: 'Güneş Paneli Kurulumu',
        title_en: 'Solar Panel Installation',
        description_tr: 'Profesyonel güneş paneli kurulum hizmeti',
        description_en: 'Professional solar panel installation service',
        icon: '☀️',
        features: '[]',
        price: null
      },
      {
        id: 2,
        title_tr: 'Rüzgar Enerjisi',
        title_en: 'Wind Energy',
        description_tr: 'Rüzgar türbini kurulum ve bakım hizmeti',
        description_en: 'Wind turbine installation and maintenance service',
        icon: '💨',
        features: '[]',
        price: null
      },
      {
        id: 3,
        title_tr: 'Enerji Depolama',
        title_en: 'Energy Storage',
        description_tr: 'Akıllı enerji depolama sistemleri',
        description_en: 'Smart energy storage systems',
        icon: '🔋',
        features: '[]',
        price: null
      }
    ]
  }

  // Initialize
  loadServices()

  return {
    services,
    isLoadingData,
    loadServices
  }
}